import React, { useState } from "react";
import { Modal, ModalHeader, ModalFooter, ModalContent, Button, Text, Heading, Checkbox, ExternalLink } from "@netapp/bxp-design-system-react";
import { AnonuncementIcon } from "@netapp/bxp-design-system-react/icons/monochrome"
/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx, css } from '@emotion/react'
import { useTranslation } from 'react-i18next';
import { whatsNew as i18nNamespace } from "../../../../i18n/namespace";

const infoGridCss = css`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 24px;
    height: 500px;
`;

const itemContent = css`
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

const externalLink = css`
    margin: auto 0 10px;
`;

const modalConentCss = css`
    height: 500px;
    overflow: hidden;
`;

const modalInnerConent = css`
    scrollbar-color: var(--border-scroller) var(--background-main);
    scrollbar-width: thin;
    overflow-x: hidden;
    overflow-y: scroll;
    height: 100%;
`;

const textHeadingDescription = css`
  width: 100%;
  max-width: 205px;
  white-space: pre-wrap;
  word-wrap: break-word;
`;

const announcementIcon = css`
  width: 22.84px;
  height: 22.28px;
  vertical-align: middle;
  path {
    fill: var(--notification-information) !important;
  }
`;

function WhatsNew ({ whatsNewConfig, handleCheckboxChange, onClose}) {
    const [isWhatsNew, setWhatsNew] = useState(false);
    const [isChecked, setIsChecked] = useState(false);
    const { t } = useTranslation(i18nNamespace);

    const close = () => {
        if(isChecked) {
            handleCheckboxChange(isChecked)
        }
        if (onClose) {
            onClose()
        }
        setWhatsNew(true);
    };

    if (!isWhatsNew) {
        return <Modal>
            <ModalHeader>
                <AnonuncementIcon css={announcementIcon} />{t('whats_new')}
            </ModalHeader>
            <ModalContent css={modalConentCss}>
                <div css={modalInnerConent}>
                    <Text>
                        {t('we_simplified_concepts')}
                        <Text style={{ marginBottom: 16 }}>
                            {t('access_to_org_resources')}
                        </Text>
                    </Text>
                    <section css={infoGridCss}>
                        {
                            whatsNewConfig(t).map((data, i) => (
                                <article key="i" css={itemContent}>
                                    {data.img}
                                    <div>
                                        <Heading level={3} style={{ marginBottom: 4 }}>
                                            <div css={textHeadingDescription}>{data.title}</div>
                                        </Heading>
                                        <Text css={textHeadingDescription}>{data.content}</Text>
                                    </div>
                                    <ExternalLink variant="text" href={data.learnMore} includeArrow={true} css={externalLink}>
                                            {t('learn_more')}
                                    </ExternalLink>
                                </article>
                            ))
                        }
                    
                    </section>
                </div>          
                <div style={{ position: "relative" }}>
                    <Checkbox
                        checked={isChecked}
                        onChange={() => setIsChecked(!isChecked)}
                        style={{ position: "absolute", top: 10 }}
                    >
                        {t('dont_show_again')}
                    </Checkbox>
                </div>                   
            </ModalContent>
            
            <ModalFooter>
                
                <Button onClick={close}>{t('close')}</Button>
            </ModalFooter>
        </Modal>
    }
    return ""
}

export default WhatsNew;
